export const registrationForm = {
  registrationAlias: "昵称",
  registrationName: "名字",
  registrationLastName: "姓氏",

  registrationEmail: "电子邮件",
  registrationEmail_message: "请输入有效的邮箱",
  registrationEmail_required: "邮箱是必需的",
  registrationEmail_specialChar: "特殊字符不允许",
  registrationEmail_CharStartEnd: "邮箱不能以特殊字符开始或结束",
  registrationEmail_CharConsecutive: "邮箱不能有连续的特殊字符",

  registrationPhoneNumber: "电话号码",
  registrationPhoneNumber_message: "请输入有效的电话号码",
  registrationPhoneNumber_tooltip: "该电话号码将用于验证移动支付",
  registrationBirthdate: "出生日期",
  registrationBirthdate_message: "你必须年满18岁才能注册",
  registrationNational_id: "身份证",
  registrationId_message: "请输入你的身份证",
  registrationNationalIdNumbersOnly: "只允许0到9之间的数字",
  registrationState: "省份",
  registrationSelect_state: "选择省份",
  registrationCity: "城市",
  registrationSelect_city: "选择城市",
  registrationSelectDate: "出生日期",
  registrationPassword: "密码",
  registrationRepeatPassword: "重复密码",
  registrationRepeatPassword_required: "请重复密码",
  registrationPasswordNotMatch: "密码不匹配",
  registrationPasswordMinLength: "密码必须至少8个字符",
  registrationReferralCode: "推荐码 (可选)",
  registrationTermsAndConditions: "条款和条件",
  registrationTermsAndConditions_: "我接受",
  registrationAcceptTerms: "您必须接受条款和条件",
  registrationAcceptTermsAgeCondition: "并且年满18岁",
  registrationAcceptTermsRegister: "注册",

  registrationAliasUnavailable: "此昵称已被使用，请选择另一个",
  registrationAliasChecking: "检查昵称可用性...",
  registrationAliasAvailable: "此昵称可用",

  registrationAccountValidationModal: "注册错误",
  registrationValidationModalEmail: "此用户已在系统中注册。请登录或使用不同的电子邮件地址注册。",
  registrationValidationModalPhone: "电话号码已注册,请使用另一个电话号码。",
  registrationValidationModalId: "身份证已注册,请使用另一个身份证号码。",
  registrationValidationModalError: "出现错误，请检查您的数据。",

  // Email verification (deprecated - now auto-login)
  registrationEmailVerificationTitle: "验证您的电子邮件",
  registrationEmailVerificationMessage:
    "我们已向您的电子邮件地址发送了一封包含验证链接的邮件。请检查您的收件箱并点击链接来验证您的账户。",

  registrationBonusTitle: "首选奖金",
  registrationFormBonusSlot: "老虎机",
  registrationFormBonusCasino: "现场赌场",
  registrationFormBonusParley: "Parley",

  registrationSuccessTitle: "注册成功!",
  registrationSuccessMessage: "欢迎! 您已自动登录。",
  registrationError: "注册错误",
  registrationErrorMessage: "注册完成，但我们无法自动登录。请手动登录。",
};
